import React from 'react';

type Props = {
  children: React.ReactNode;
};

export default function SubTitle(props: Props) {
  let { children } = props;

  return <h2 className="font-sans text-raw-umber font-medium text-xl pb-1 my-2 whitespace-nowrap">{children}</h2>;
}
